import { render, staticRenderFns } from "./detailsTop.vue?vue&type=template&id=e059af06&scoped=true&"
import script from "./detailsTop.vue?vue&type=script&lang=ts&setup=true&"
export * from "./detailsTop.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./detailsTop.vue?vue&type=style&index=0&id=e059af06&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e059af06",
  null
  
)

export default component.exports